import { Link } from "react-router-dom";

interface FooterProps {
  // This element is `position: fixed`, so it takes no space in normal
  // document flow - a ref on a non-fixed wrapper around it would always
  // measure 0 height. Callers that need this footer's real rendered height
  // (e.g. to keep other fixed/absolute layout from sitting underneath it)
  // must attach their ref/observer directly to this element instead.
  footerRef?: (node: HTMLElement | null) => void;
}

const Footer = ({ footerRef }: FooterProps) => {
  return (
    <footer
      ref={footerRef}
      className="fixed bottom-0 left-0 right-0 z-[100] w-full bg-[#002244] px-4 py-3 flex flex-col md:flex-row items-center justify-between text-xs text-white"
    >
      <span className="font-medium">
        © {new Date().getFullYear()} Senior Citizen Welfare. Powered by NeGD |
        MeitY, Government of India.
      </span>
      <nav className="mt-1 flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
        <Link
          to="/about-us"
          className="text-white font-medium hover:opacity-80"
        >
          About Us
        </Link>
        <span className="h-4 w-px bg-[#9cbfe3]" aria-hidden="true" />
        <Link
          to="/privacy-policy"
          className="text-white font-medium hover:opacity-80"
        >
          Privacy Policy
        </Link>
        <span className="h-4 w-px bg-[#9cbfe3]" aria-hidden="true" />
        <Link
          to="/terms-conditions"
          className="text-white font-medium hover:opacity-80"
        >
          Terms &amp; Conditions
        </Link>
      </nav>
    </footer>
  );
};

export default Footer;
